import { AvForm, AvField, AvInput } from 'availity-reactstrap-validation';
import React, { useEffect, useState } from 'react';
import toastr from 'toastr';
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CustomInput,
  FormGroup,
  Label,
  Row,
  Input,
} from 'reactstrap';
import useAttachement from '../../helpers/hooks/useAttachments';
import usePost from '../../helpers/hooks/usePost';
import { useHistory } from 'react-router-dom';
import usePatch from '../../helpers/hooks/usePatch';
import useGet from '../../helpers/hooks/useGet';

const VegetableDetails = ({
  match: {
    params: { id },
  },
}) => {
  const history = useHistory();
  const [vegetable, , vegetableLoading] = useGet(`/vegetables/${id}`, true);
  const [selectedImage, setSelectedImage] = useState();
  const [units, setUnits] = useState(['']);
  const [attributes, setAttributes] = useState([{ title: '', values: [''] }]);
  const [postVegetable, postedData, postingError, dataPosting] = usePatch(
    `/vegetables/${id}`
  );
  const { upload, error, loading: imagesUploading, urls } = useAttachement();
  const handleAddSellingUnit = () => {
    setUnits([...units, '']);
  };
  const handleUnitInputChange = ({ target: { value, name } }) => {
    const temp = [...units];
    temp[name] = value;
    setUnits(temp);
  };
  const handleDelSellingUnit = (index) => {
    const temp = units.slice();
    if (temp.length === 1) {
      return;
    }
    temp.splice(index, 1);

    setUnits(temp);
  };
  const handleAddSellingAttribute = () => {
    const temp = [...attributes];
    temp.push({ title: '', values: [''] });
    setAttributes(temp);
  };
  const handleDeleteSettingAttribute = (index) => {
    const temp = [...attributes];
    if (temp.length === 1) {
      return;
    }
    temp.splice(index, 1);
    setAttributes(temp);
  };
  const handleAttributeTitleChange = ({ target: { value, name } }) => {
    const temp = [...attributes];
    temp[name].title = value;
    setAttributes(temp);
  };
  const handleAttributeValueTitleChange = ({ target: { value, name } }) => {
    const spl = name.split('__');
    const temp = [...attributes];
    temp[spl[0]].values[spl[1]] = value;
    setAttributes(temp);
  };
  const handleDeleteAttributeValue = (parentIndex, currentIndex) => {
    const temp = [...attributes];
    if (temp[parentIndex].values.length === 1) {
      return;
    }
    temp[parentIndex].values.splice(currentIndex, 1);
    setAttributes(temp);
  };
  const handleAddAttributeValue = (parentIndex) => {
    const temp = [...attributes];
    temp[parentIndex].values.push('');
    setAttributes(temp);
  };
  const handleSubmit = (event, errors, values) => {
    if (dataPosting) {
      return;
    }
    if (
      errors.length > 0 ||
      units.some((x) => x.length === 0) ||
      attributes.some(
        (x) => x.values.some((y) => y.length === 0) || x.title.length === 0
      )
    ) {
      return toastr.warning('Please fix errors in the form');
    }
    const obj = {
      ...values,
      sellingUnits: units,
      sellingAttributes: attributes,
    };
    if (selectedImage) {
      upload([selectedImage]).then((_urls) => {
        postVegetable({ ...obj, image: _urls[0] });
      });
    } else {
      postVegetable(obj);
    }
  };
  useEffect(() => {
    if (postingError) {
      console.log(postingError);
      toastr.error(postingError.error.message);
    }
  }, [postingError]);
  useEffect(() => {
    if (postedData) {
      toastr.success('Vegetable has been updated successfully');
      history.push('/system/vegetables');
    }
  }, [history, postedData]);
  useEffect(() => {
    if (vegetable) {
      setUnits(vegetable.sellingUnits);
      setAttributes(vegetable.sellingAttributes);
    }
  }, [vegetable]);
  return (
    <>
      <div className='page-content'>
        <Container fluid>
          <AvForm className='needs-validation' onSubmit={handleSubmit}>
            <Row>
              <Col md={{ size: 8, offset: 2 }}>
                <h4>Edit Crop</h4>
                <Card>
                  <CardBody>
                    <FormGroup>
                      <Label htmlFor='name'>Name</Label>
                      <AvField
                        name='name'
                        placeholder='Name'
                        type='text'
                        errorMessage='Enter Name'
                        className='form-control'
                        validate={{ required: { value: true } }}
                        id='name'
                        value={vegetable?.name}
                      />
                    </FormGroup>
                    <Row className='mb-3'>
                      <Col md={1}>
                        <img
                          src={vegetable?.image}
                          className='rounded-circle avatar-sm card-img'
                        />
                      </Col>
                      <Col md={11}>
                        {' '}
                        <FormGroup>
                          <div className='custom-file'>
                            <CustomInput
                              type='file'
                              className='custom-file-input'
                              id='image'
                              accept='image/*'
                              onChange={(e) => {
                                setSelectedImage(e.target.files[0]);
                              }}
                            />
                            <Label
                              className='custom-file-label'
                              htmlFor='image'
                            >
                              {selectedImage
                                ? selectedImage.name
                                : 'Change Image'}
                            </Label>
                          </div>
                          {selectedImage && (
                            <span className='d-block font-size-20 text-danger text-right'>
                              <i
                                onClick={() => setSelectedImage(null)}
                                style={{ cursor: 'pointer' }}
                                className='ri-close-line'
                              ></i>
                            </span>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormGroup>
                          <AvInput
                            tag={CustomInput}
                            type='checkbox'
                            label='Used in Rabi Crops'
                            name='usedInRabiCrop'
                            validate={{ required: { value: false } }}
                            checked={vegetable?.usedInRabiCrop}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvInput
                            tag={CustomInput}
                            type='checkbox'
                            label='Used in Khareef Crops'
                            name='usedInKhareefCrop'
                            validate={{ required: { value: false } }}
                            checked={vegetable?.usedInKhareefCrop}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <div className='border mb-3'></div>
                    <Row>
                      <Col>
                        <h4 className='text-center mb-3'>Selling Units</h4>
                        {units.map((x, i) => (
                          <div className='d-flex justify-content-between '>
                            <div className=' w-100'>
                              <Input
                                className='mb-3'
                                placeholder='Enter unit name'
                                value={units[i]}
                                name={i}
                                onChange={handleUnitInputChange}
                              />
                            </div>
                            <i
                              onClick={() => handleDelSellingUnit(i)}
                              style={{ cursor: 'pointer' }}
                              className='font-size-18 text-pink ri-delete-bin-fill ml-2'
                            ></i>
                          </div>
                        ))}
                        <div className='text-center'>
                          <Button
                            onClick={handleAddSellingUnit}
                            color='danger'
                            type='button'
                            small
                            outline
                          >
                            <i className='mdi mdi-plus align-middle '></i>
                          </Button>
                        </div>
                      </Col>
                      <Col className='border-left'>
                        <h4 className='text-center mb-3'>Selling Attributes</h4>
                        {attributes.map((x, i) => (
                          <>
                            <div className='d-flex justify-content-between '>
                              <div className=' w-100'>
                                <Input
                                  className='mb-3'
                                  placeholder='Enter attribute name'
                                  value={attributes[i].title}
                                  name={i}
                                  onChange={handleAttributeTitleChange}
                                />
                              </div>
                              <i
                                onClick={() => handleDeleteSettingAttribute(i)}
                                style={{ cursor: 'pointer' }}
                                className='font-size-18 text-pink ri-delete-bin-fill ml-2'
                              ></i>
                            </div>
                            <div>
                              {x.values.map((y, ii) => (
                                <>
                                  <div className='d-flex justify-content-between border-left pl-4'>
                                    <div className=' w-100'>
                                      <Input
                                        className='mb-3 form-control-sm'
                                        placeholder='Enter attribute name'
                                        value={attributes[i].values[ii]}
                                        name={i + '__' + ii}
                                        onChange={
                                          handleAttributeValueTitleChange
                                        }
                                      />
                                    </div>
                                    <i
                                      onClick={() =>
                                        handleDeleteAttributeValue(i, ii)
                                      }
                                      style={{ cursor: 'pointer' }}
                                      className='font-size-14 text-pink  ri-close-line ml-2'
                                    ></i>
                                    <i
                                      onClick={() => handleAddAttributeValue(i)}
                                      style={{ cursor: 'pointer' }}
                                      className='font-size-14 text-primary  mdi mdi-plus align-middle ml-2'
                                    ></i>
                                  </div>
                                </>
                              ))}
                            </div>
                          </>
                        ))}
                        <div className='text-center'>
                          <Button
                            onClick={handleAddSellingAttribute}
                            color='danger'
                            type='button'
                            small
                            outline
                          >
                            <i className='mdi mdi-plus align-middle '></i>
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <div className='text-right mb-5'>
                  <Button
                    color='primary'
                    disabled={dataPosting || imagesUploading}
                  >
                    {dataPosting || imagesUploading ? 'Saving...' : 'Save Crop'}
                  </Button>
                </div>
              </Col>
            </Row>
          </AvForm>
        </Container>
      </div>
    </>
  );
};
export default VegetableDetails;
